// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it

import { Child } from 'pym.js';
// import ai2html from './ai2html-graphic.html';
import * as d3 from 'd3';

import grid_data from './data/grid2.json';

import meta from './data/meta.json';
import Zion from './utils/Zion';


// utils
import { stylePremium } from './utils/helpers';

// styles
import './styles/index.scss';
import './styles/graphic.scss';
import { start } from '@popperjs/core';

const pkg = require('../package.json');

let ai2html = null;

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  ai2html = require('./ai2html-graphic.html');
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

console.clear();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

const colorMap = {
  'Blizzard Warning': '#c52622',
  'Blizzard Watch': '#c52622',
  'Wind Chill Warning': '#f4d064',
  'Wind Chill Watch': '#f4d064',
  'Lake Effect Snow Warning': '#ff6c46',
  'Lake Effect Snow Watch': '#ff6c46',
  'Winter Storm Warning': '#b74dbc',
  'Winter Storm Watch': '#b74dbc',
  'Ice Storm Warning': '#53a796',
  'Winter Weather Advisory': '#52a797',
  'Extreme Cold Watch': '#b6c9ef',
  'Extreme Cold Warning': '#4065d8',
  'Cold Weather Advisory': '#999999',
};

function draw() {
  if (process.env.NODE_ENV === 'development') {
    // the code below applies the ai2html
    // during development mode.

    const figure = document.querySelector('#ai2html-graphic');
    figure.innerHTML = ai2html;

    // If you want to write code for this graphic,
    // move this stuff outside the if block that it's in.
  }
}

// MY GRAPHIC

const IS_MOBILE = window.innerWidth < 500;

// DATA PROCESSING
d3.json('https://ix.cnn.io/data/wx-winter-alerts/alerts.geojson').then((data) => {
  // reduce geojson to features
  const dataFeatures = data.features;

  // error handling if no winter weather alerts
  let dummyFlag = false;
  if (dataFeatures.length == 0) {
    const dummyData = {
      type: 'Feature',
      properties: {
        alert: 'Blizzard warning', name: 'Ada County', state: 'Alaska', population: 0,
      },
      geometry: { type: 'Polygon', coordinates: [[[-116.512502, 43.80716], [-116.282019, 43.807364], [-116.263384, 43.793791], [-115.992799, 43.595084], [-115.975719, 43.591437], [-115.974881, 43.365019], [-115.978651, 43.113431], [-116.266207, 43.112268], [-116.385955, 43.193576], [-116.425275, 43.293542], [-116.511897, 43.290519], [-116.473597, 43.459217], [-116.513123, 43.634182], [-116.512502, 43.80716]]] },
    };
    dataFeatures.push(dummyData);
    dummyFlag = true;
  }

  // extract properties
  const dataSimple = dataFeatures.map(a => a.properties).map(a => ({
    ...a, population: +a.population,
  }));

  // logic to handle counties with multiple warnings
  // create property that combines county and state to evaluate duplicates
  const dataSimple2 = dataSimple.map(
    (obj) => {
      const countyState = `${obj.name.replace(/\s+/g, '').toLowerCase()}_${obj.state.replace(/\s+/g, '').toLowerCase()}`;
      return { ...obj, countyState };
    },
  );


  // Function to remove objects with duplicated countyState, keeping one based on alert priority
  function removeDuplicates(array) {
    const result = [];
    const seenCountyStates = {};

    // Iterate through each object in the array
    for (const obj of array) {
      const { countyState, alert } = obj;

      // Check if countyState is duplicated
      if (!seenCountyStates[countyState]) {
        // If not duplicated, add to result and mark as seen
        result.push(obj);
        seenCountyStates[countyState] = true;
      } else {
        // If duplicated, compare the alert priority and update if necessary
        const existingObj = result.find(item => item.countyState === countyState);
        if (compareAlertPriority(alert, existingObj.alert) > 0) {
          // Replace the existing object with the one with higher priority
          existingObj.alert = alert;
        }
      }
    }

    return result;
  }

  // Function to compare the priority of two alert values
  function compareAlertPriority(alert1, alert2) {
    const priorityOrder = ['Blizzard Warning', 'Winter Storm Warning', 'Ice Storm Warning', 'Lake Effect Warning', 'Wind Chill Warning', 'Blizzard Watch', 'Winter Storm Watch', 'Lake Effect Watch', 'Wind Chill Watch', 'Winter Weather Advisory'];
    return priorityOrder.indexOf(alert1) - priorityOrder.indexOf(alert2);
  }

  // Remove duplicates from the array based on the criteria
  const dataSimple3 = removeDuplicates(dataSimple2);

  // END duplicate handling


  // create an array of objects for each unique state and each unique alert and sum the population affected for each
  const dataByState = Object.values(dataSimple3.reduce((acc, { state, alert, population }) => {
    const key = `${state}_${alert}`; // unique combination of state and alert
    acc[key] = acc[key] || { state, alert, population: 0 };
    acc[key].population += population;
    return acc;
  }, {}));

  console.log(dataByState);

  // group data by state and create new object
  const statesObject = Object.groupBy(dataByState, ({ state }) => state);
  // convert object into array of objects for each state
  const statesArray = Object.keys(statesObject).map(key => ({ state: key, alerts: statesObject[key] }));


  const alertData = grid_data.map(
    (state) => {
      const stateData = statesArray.find(d => d.state === state.name);
      const alerts = stateData ? stateData.alerts : [];

      // get population percent
      alerts.map((obj) => {
        const state_pop = state.total_population;
        const alert_pop = obj.population;
        const pop_pct = (alert_pop / state_pop) * 100;
        obj.pop_pct = pop_pct;
        return obj;
      });
      // returning a new object by spreading (...) the "state" object and adding alerts from the data
      return { ...state, alerts };
    },
  );

  // UPDATE TEXT
  // total people under winter weather alerts
  const totalPop = dataSimple3.reduce((n, { population }) => n + population, 0);
  d3.select('#total-pop').html(totalPop.toLocaleString());


  // states under alerts
  d3.select('#states-total').html(dataByState.length);

  // make map

  const map = d3.select('#map')
    .append('div')
    .attr('class', 'states-map')
    .append('div')
    .attr('class', 'states');


  grid_data.forEach((d) => {
    const state = map
      .append('div')
      // .attr('class', 'state')
      .attr('id', d.abbr)
      .attr('class', () => {
        const state = alertData.find(e => e.abbr === d.abbr);
        if (state.alerts.length > 0) {
          if (dummyFlag == false) {
            return 'state active';
          }
        }
        return 'state inactive';
      })
      .style('aspect-ratio', '1/1')
      .style('grid-column', d.x + 1)
      .style('grid-row', d.y + 1);

    state
      .append('header')
      .attr('class', 'text-halo state-abbr')
      .style('z-index', 1)
      .text(d.abbr);

    state
      .append('header')
      .attr('class', 'state-abbr')
      .text(d.abbr);


    alertData.forEach((i) => {
      // alert_data.forEach((i) => {
      if (d.name == i.name) {
        state
          .append('ul')
          .attr('class', 'warnings')
          .selectAll('ul')
          .data(i.alerts)
          .enter()
          .append('li')
          .style('background-color', e => colorMap[e.alert] || '#999999')
          .attr('class', e => e.alert.replace(/\s+/g, '_').toLowerCase())
          .style('height', d => `${d.pop_pct}%`);
      }
    });
  });

  // AREA CHART GRAPHIC

  // highhest pop affected
  const highest = dataByState.sort((a, b) => b.pop_pct - a.pop_pct)[0];
  const starterState = alertData.find(d => d.name === highest.state);


  // TOOLTIP
  const tooltip = d3.select('#chart')
    .append('div')
    .style('opacity', 0)
    .attr('class', 'tooltip shadowed')
    .style('position', 'absolute')
    .style('background-color', 'white');

  function nFormatter(num, digits) {
    const lookup = [
      { value: 1, symbol: '' },
      { value: 1e3, symbol: 'k' },
      { value: 1e6, symbol: 'M' },
      { value: 1e9, symbol: 'G' },
      { value: 1e12, symbol: 'T' },
      { value: 1e15, symbol: 'P' },
      { value: 1e18, symbol: 'E' },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup.slice().reverse().find(item => num >= item.value);
    return item ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : '0';
  }

  function massageData(data) {
    if (data) {
      const { alerts } = data;
      const alertRows = [];
      alerts.forEach((d) => {
        const alertRow = {};
        alertRow.Alert = d.alert;
        alertRow['State pop. under alert'] = `${Math.min(100, Math.round(d.pop_pct * 10) / 10)}%`;
        alertRow['Total people'] = nFormatter(d.population, 1);
        alertRow['State pop.'] = nFormatter(data.total_population, 1);
        alertRows.push(alertRow);
      });

      const res = alertRows.sort((a, b) => Number(b['State pop. under alert'].replace(/\d+% ?/g, '')) - Number(a['State pop. under alert'].replace(/\d+% ?/g, '')));
      return res;
    }
    return [];
  }

  const starterStateData = massageData(starterState);

  function buildTable(data) {
    d3.select('table').remove();

    const table = tooltip.append('table').attr('class', 'table');
    const thead = table.append('thead');
    const tbody = table.append('tbody');

    const theaders = ['Alert', 'State pop. under alert', 'Total people', 'State pop.'];

    thead.append('tr')
      .selectAll('th')
      .data(theaders)
      .enter()
      .append('th')
      .attr('class', d => d.replace(/\s+/g, '_').toLowerCase().replace(/\W/g, ''))
      .text(d => d);

    const rows = tbody.selectAll('tr')
      .data(data)
      .enter()
      .append('tr');

    // create a cell in each row for each column
    const cells = rows.selectAll('td')
      .data(row => theaders.map(column => ({ column, value: row[column] })))
      .enter()
      .append('td')
      .attr('class', (d, i) => theaders[i].replace(/\s+/g, '_').toLowerCase().replace(/\W/g, ''))
      .html((d) => {
        if (d.column == 'Alert') {
          return `<div class='alertWrap'><span style='background-color: ${colorMap[d.value] || '#999999'}' class='alertRect ${d.value.replace(/\s+/g, '_').toLowerCase()}'></span><span>${d.value}</span></div>`;
        }

        return d.value;
      });
      // .text(d => d.value);
  }

  buildTable(starterStateData);

  // Three function that change the tooltip when user hover / move / leave a cell
  const mouseover = function (event, d) {
    const state = d3.select(this.parentNode).selectAll('.areaChart').attr('id');
    // const state = d3.select(this).attr('id');
    const stateData = alertData.find(d => d.name.replace(/\s+/g, '_').toLowerCase() === state);

    const newStateData = massageData(stateData);
    buildTable(newStateData);

    if (newStateData.length > 0) {
      tooltip.style('opacity', 1);
    } else {
      tooltip.style('opacity', 0);
    }
  };

  const mousemove = function (e, d) {
    tooltip;

    const element = d3.select('.tooltip').node();
    const theight = element.getBoundingClientRect().height;

    if (IS_MOBILE) {
      const coords = d3.pointer(e);
      const xPos = coords[0] - 110;
      const yPos = coords[1] - theight - 10;

      tooltip
        .style('left', `${0 - (d3.select(this).attr('width') / 2 - 5)}px`)
        .style('top', `${yPos}px`);
    } else {
      const coords = d3.pointer(e);
      const xPos = coords[0] - 110;
      const yPos = coords[1] - theight - 10;

      tooltip
        .style('left', `${xPos}px`)
        .style('top', `${yPos}px`);
    }
  };

  const mouseleave = function (d) {
    tooltip.style('opacity', 0);
  };

  d3.select('#chart').append('div');

  const margin = {
    top: 15, right: 15, bottom: 15, left: 50,
  };
  // const width = 335 - margin.left - margin.right;
  // const height = 270 - margin.top - margin.bottom;

  const width = 180 - margin.left - margin.right;
  const height = 140 - margin.top - margin.bottom;

  const svg = d3
    .select('#chart')
    .append('svg')
    .attr('width', width + margin.left + margin.right)
    .attr('height', height + margin.top + margin.bottom)
    .append('g')
    .attr('class', 'svg')
    .attr('transform', `translate(${margin.left},${margin.top})`);

  const yScale = d3.scaleLinear()
    .domain([0, 100])
    .range([height, 0]);

  const bars = svg
    .append('g')
    .attr('class', 'bars');

  // FUNCTION
  function makeChart(data) {
    d3.selectAll('option').attr('selected', null);
    d3.select(`option[value='${data.abbr}']`).attr('selected', true);

    const stateAlerts = data.alerts;

    // need to make data d3 stack friendly
    const niceData = stateAlerts.reduce(
      (obj, item) => Object.assign(obj, { [item.alert]: item.pop_pct, state: item.state }), {},
    );

    const allKeys = Object.keys(niceData);
    const keys = allKeys.filter(val => val !== 'state');

    const stack = d3.stack()
      .order(d3.stackOrderAscending)
      .keys(keys)([niceData]);

    // Set up transition.
    const dur = 500;
    const t = d3.transition().duration(dur);


    d3.selectAll('#group').remove();
    d3.selectAll('.noData').remove();

    if (stack.length == 0) {
      svg
        .append('text')
        .attr('x', width / 2)
        .attr('y', height / 2)
        .attr('class', 'axis-label noData')
        .attr('text-anchor', 'middle')
        .text('No alerts');
    }

    bars
      .attr('id', () => {
        if (niceData.state) {
          return niceData.state.replace(/\s+/g, '_').toLowerCase();
        }
        return 'no-state';
      })
      .attr('class', 'areaChart');


    bars
      .selectAll('g')
      .data(stack)
      .join(
        enter => enter
          .append('g')
          .attr('id', 'group')
          // .style('opacity', 0.9)
          .attr('class', d =>
            // console.log(d);
            d.key.replace(/\s+/g, '_').toLowerCase()),
        null, // no update function

        (exit) => {
          exit
            .transition()
            .duration(dur / 2)
            .remove();
        },
      )
      .selectAll('rect')
      .data(d =>

        // Propagate the key from the parent series to each data point
        d.map(point => ({ ...point, key: d.key })))
      .join(
        enter => enter
          .append('rect')
          .attr('class', 'bar')
          .attr('fill', d => colorMap[d.key] || '#999999')
          .attr('x', 0)
          .attr('y', d => yScale(d[1]))
          .attr('height', d => yScale(d[0]) - yScale(d[1]))
          .attr('width', width),
        null,
        (exit) => {
          exit
            .transition()
            .duration(dur / 2)
            .style('fill-opacity', 0)
            .remove();
        },
      )
      .transition(t)
      .delay((d, i) => i * 20)
      .attr('x', 0)
      .attr('y', d => yScale(d[1]))
      .attr('height', d => yScale(d[0]) - yScale(d[1]))
      .attr('width', width);
  }

  makeChart(starterState);

  svg
    .append('rect')
    .attr('class', 'rect')
    .attr('width', width)
    .attr('height', height)
    .style('fill', 'transparent')
    .on('mouseover', mouseover)
    .on('mousemove', mousemove)
    .on('mouseleave', mouseleave);

  svg
    .append('text')
    .attr('x', 0)
    .attr('y', 0)
    .attr('dy', 10)
    .attr('dx', -5)
    .attr('class', 'axis-label')
    .attr('text-anchor', 'end')
    .text('100%');

  svg
    .append('text')
    .attr('x', 0)
    .attr('y', 0)
    .attr('dy', 30)
    .attr('dx', -5)
    .attr('class', 'axis-label')
    .attr('text-anchor', 'end')
    .text('under');

  svg
    .append('text')
    .attr('x', 0)
    .attr('y', 0)
    .attr('dy', 50)
    .attr('dx', -5)
    .attr('class', 'axis-label')
    .attr('text-anchor', 'end')
    .text('alert');

  svg
    .append('text')
    .attr('x', 0)
    .attr('y', height)
    .attr('dx', -5)
    .attr('class', 'axis-label')
    .attr('text-anchor', 'end')
    .text('0%');

  // dropdown!
  d3.select('#dropdown').on('change', (event) => {
    const selectedState = event.target.value;
    const selectedData = alertData.find(d => d.abbr === selectedState);

    makeChart(selectedData);
  });

  // click state to change data
  d3.selectAll('.state').on('mouseover', (d) => {
    d3.select(d.target).style('box-shadow', 'inset 0 0 2px #000');
    // d3.select(this).style('border', '3px solid #262626');
  });

  d3.selectAll('.state').on('mouseout', (d) => {
    d3.selectAll('.state').style('box-shadow', 'inset 0 0 0px #000');
  });

  d3.selectAll('.state').on('click', (d) => {
    const selectedState = d.target.id;
    const selectedData = alertData.find(d => d.abbr === selectedState);
    makeChart(selectedData);
  });

  d3.select('#map').on('mouseover', (d) => {
    d3.select('#map').style('z-index', 1000);
    d3.select('#chart-container').style('z-index', 1);
  });

  d3.select('#chart-container').on('mouseover', (d) => {
    d3.select('#map').style('z-index', 1);
    d3.select('#chart-container').style('z-index', 1000);
  });


  pymChild.sendHeight();
});
